import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Drawer from "./components/Drawer";
// import WrongCuadreWarning from "./components/WrongCuadreWarning";
import { ToastContainer } from "react-toastify";
// import Snackbar from "@shared/components/Snackbar";
// import StatusAlert from "./components/StatusAlert";
// import SWRFetcher from "./components/SWRFetcher";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// import ResolveAuth from "./pages/ResolveAuth";
// import RealTimeUpdates from "@shared/pages/RealTimeUpdates";
import Paper from "@material-ui/core/Paper";
import Routes from "./Routes";
import CuadreRoute from "./CuadreRoute";
// import { hot } from "react-hot-loader";
// import { newDate } from "@shared/functions";
// import { differenceInCalendarDays } from "date-fns";
// import { withProfiler } from "@sentry/browser";
// import logger from "./logService";
import "react-toastify/dist/ReactToastify.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import { useSelector, useDispatch, useStore } from "react-redux";
import { selectCommon, setCommon } from "./store/slices/common";
// import { selectAuth } from "./store/slices/auth";
import jwtDecode from "jwt-decode";
// import { selectTheme, setSWSTatus } from "./store/slices/ui";
import { selectTheme } from "./store/slices/ui";
import SyncManager from "./components/sync/SyncManager";
import { useAuth } from "./Hooks/useAuth";
import usePouchReplication from "./Hooks/usePouchReplication";
import { localPouchPrefix, pouches_db } from "./config";
import { logger } from "./functions/logger";
import { logCuadreSliceReset } from "./functions/logCuadreSliceReset";
import { recoverCommon } from "./functions/recoverCommon";
import usePouchSync from "./Hooks/usePouchSync";
import { getLocalToken } from "@shared/functions";
// import { Workbox } from "workbox-window";
// import { useDispatch } from "react-redux";
// import { UseCobroDeltaChanges } from "@shared/server/fetcher";
// import { useEffect } from "react";

const App = () => {
  const [remoteDb, setRemoteDb] = useState({
    gastos: null,
    debtors: null,
    payments: null,
    loans: null,
  });

  console.log("App is being mounted.");

  const localToken = getLocalToken();

  const queuesSync = usePouchSync(
    pouches_db.SYNC_QUEUES,
    `queues-${localToken}`
  );
  const gastosSync = usePouchSync(pouches_db.GASTOS, remoteDb.gastos);
  const debtorsSync = usePouchSync(pouches_db.NEW_DEBTORS, remoteDb.debtors);
  const loanssSync = usePouchSync(pouches_db.NEW_LOANS, remoteDb.loans);
  const paymentsSync = usePouchSync(pouches_db.PAYMENTS, remoteDb.payments);

  const gastosReplication = usePouchReplication(
    pouches_db.GASTOS,
    pouches_db.GASTOS
  );
  const debtorsReplication = usePouchReplication(
    pouches_db.NEW_DEBTORS,
    pouches_db.NEW_DEBTORS
  );
  const loansReplication = usePouchReplication(
    pouches_db.NEW_LOANS,
    pouches_db.NEW_LOANS
  );
  const paymentsReplication = usePouchReplication(
    pouches_db.PAYMENTS,
    pouches_db.PAYMENTS
  );

  const paymentsConflicts = usePouchReplication(
    pouches_db.SYNC_CONFLICTS,
    pouches_db.SYNC_CONFLICTS
  );

  // console.log({ gastosReplication });
  // console.log({ debtorsReplication });
  // console.log({ loansReplication });
  // console.log({ paymentsReplication });

  const { data: authData } = useAuth();
  const store = useStore();
  const [forceLogout, setForceLogout] = useState(false);
  const common = useSelector(selectCommon);
  const palette = useSelector(selectTheme);
  const dispatch = useDispatch();
  const history = useHistory();
  const commonRecoveryTried = useRef(false);
  // Shown when the browser DENIES persistent storage: this device can have its
  // offline data evicted by the OS. Warn the collector to install the app so
  // persistence is granted (installed PWAs are almost always granted it).
  const [showStorageWarning, setShowStorageWarning] = useState(false);

  // if ("serviceWorker" in navigator && import.meta.env.PROD) {
  //   const wb = new Workbox("sw.js");

  //   wb.addEventListener("installed", (event) => {
  //     if (event.isUpdate) {
  //       dispatch(setSWSTatus({ status: "updated" }));
  //     } else {
  //       dispatch(setSWSTatus({ status: "installed" }));
  //     }
  //   });

  //   wb.register();
  // }

  // Request PERSISTENT (non-evictable) storage once at startup. This is the root
  // fix for the "SWRFetcher stuck / common empty" bug: mobile browsers give
  // best-effort storage that the OS evicts under memory pressure, wiping IndexedDB
  // (Redux `common` + PouchDB) while localStorage survives — leaving the app
  // "logged in" but context-less. If granted, that eviction can't happen.
  useEffect(() => {
    (async () => {
      try {
        if (!navigator.storage || !navigator.storage.persist) {
          logger.info("storage.persist_unsupported", "Persistent storage API unavailable", { entity: "storage" });
          return;
        }
        const already = await navigator.storage.persisted();
        const granted = already || (await navigator.storage.persist());
        logger[granted ? "info" : "warning"](
          granted ? "storage.persist_granted" : "storage.persist_denied",
          granted ? "Persistent storage granted" : "Persistent storage denied (data may be evicted)",
          { entity: "storage", context: { already_persisted: already, granted } }
        );
        if (!granted) setShowStorageWarning(true);
      } catch (e) {
        logger.warning("storage.persist_error", "Persistent storage request failed", {
          entity: "storage",
          context: { error: String(e?.message || e) },
        });
      }
    })();
  }, []);

  // TOP-LEVEL RECOVERY: runs on EVERY route (App is always mounted), not just
  // SWRFetcher. If the user is authenticated (jwt) but `common` is empty (IndexedDB
  // evicted while localStorage survived), rebuild the cuadre context — from the
  // localStorage mirror, else cuadre/init — so no page (Dashboard/Collected/...) gets
  // stranded on a loading/LoadingInspect screen. Attempts once; on total failure
  // sends the user to login (no loop).
  useEffect(() => {
    if (!authData || authData.jwt === null) return; // not logged in -> Login handles it
    if (common && common.creditor_id) return; // context present, nothing to do
    if (commonRecoveryTried.current) return; // attempt once
    commonRecoveryTried.current = true;

    let cancelled = false;
    (async () => {
      const res = await recoverCommon();
      if (cancelled) return;
      if (res) {
        // Read the store directly, not the `common` closure: this runs after an
        // await, so anything captured at render time may be stale, and a stale
        // count is the one thing this record must not report.
        logCuadreSliceReset(store.getState(), res.common?.cuadre_id ?? null, "recovery");

        dispatch(setCommon(res.common));
        logger.warning(
          res.source === "localstorage" ? "common.recovered_from_localstorage" : "common.recovered_from_cuadre_init",
          "Recovered lost cuadre context (common was empty)",
          {
            entity: "common",
            context: { source: res.source, creditor_id: res.common?.creditor_id, cuadre_id: res.common?.cuadre_id },
          }
        );
      } else {
        logger.error("common.recovery_failed", "Could not recover cuadre context; redirecting to login", {
          entity: "common",
        });
        history.replace("/login");
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [common, authData]);

  useEffect(() => {
    if (authData.jwt === null) {
      setForceLogout(false);
      return;
    }

    //TODO: Whene removing redux auth from, ensure this is working propertly

    const decodedJwt = jwtDecode(authData.jwt ?? auth.jwt);

    if (decodedJwt.exp < Date.now() / 1000) {
      // This is an INVOLUNTARY logout: forceLogout swaps the router for
      // CuadreRoute, whose catch-all <Redirect> sends the collector to /logout
      // from whatever page she was on. She pressed nothing, so the decision has
      // to leave a record or the complaint is unreproducible.
      //   token_lifetime_minutes -> is the API's token TTL shorter than a workday?
      //   expired_ago_minutes    -> was she kicked the instant it lapsed, or on a
      //                             later remount (the SW auto-update reloads
      //                             every SW_UPDATE_INTERVAL_MS)?
      //   path                   -> what she was doing when it happened.
      const nowSeconds = Math.floor(Date.now() / 1000);

      logger.warning("auth.forced_logout", "JWT expired; forcing logout", {
        entity: "auth",
        context: {
          exp: decodedJwt.exp,
          iat: decodedJwt.iat ?? null,
          now: nowSeconds,
          expired_ago_minutes: Math.round((nowSeconds - decodedJwt.exp) / 60),
          token_lifetime_minutes: decodedJwt.iat
            ? Math.round((decodedJwt.exp - decodedJwt.iat) / 60)
            : null,
          path: window.location.pathname,
        },
      });

      setForceLogout(true);
    }
  }, [authData]);

  useEffect(() => {
    const prefix = localStorage.getItem(localPouchPrefix);
    if (prefix) {
      // The gap between Login's gastos.pre_wipe and this log is the window during
      // which the OLD-prefix live sync is still running against the wiped local DB.
      logger.info("sync.remote_target_changed", "Repointing sync remotes to current prefix", {
        context: { new_prefix: prefix, gastos_remote: prefix + "_gastos" },
      });
      setRemoteDb({
        gastos: prefix + "_gastos",
        debtors: prefix + "_debtors",
        payments: prefix + "_payments",
        loans: prefix + "_loans",
      });
    }
  }, [authData]);

  /**
   *End of Delta changes implementation
  const dispatch = useDispatch();

  const { data: deltaChanges } = UseCobroDeltaChanges(common.creditor_id, common.lastCheckUpdate);

  useEffect(() => {
    if (!deltaChanges) return;
    console.log("UseEffect is being triggered", deltaChanges);

    async function proccessDeltas() {
      console.log("Here dispatch");
    }
    proccessDeltas();
  }, [deltaChanges]);

  *End of Delta changes implementation
  */

  // const displayWrongCuadreWarning = useMemo(() => {
  //   if (common.collect_date) {
  //     return differenceInCalendarDays(new Date(), newDate(common.collect_date));
  //   }
  //   return 0;
  // }, []);

  const theme = createTheme({ palette });

  return (
    <>
      <CssBaseline />
      <SyncManager />
      <ThemeProvider theme={theme}>
        {/* <RealTimeUpdates /> */}
        <Drawer />
        <Paper variant="outlined" style={{ minHeight: "100vh" }}>
          {/* <ResolveAuth /> */}
          <ToastContainer />
          {showStorageWarning && (
            <div className="alert alert-warning alert-dismissible fade show m-2" role="alert">
              <b>Advertencia:</b> Este dispositivo podr&iacute;a borrar los datos guardados sin
              conexi&oacute;n. Para evitar perder informaci&oacute;n, <b>agregue esta aplicaci&oacute;n a
              la pantalla de inicio</b> de su tel&eacute;fono (men&uacute; del navegador &rarr;
              &ldquo;Agregar a pantalla de inicio&rdquo;).
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => setShowStorageWarning(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          )}
          {/* <SWRFetcher /> */}
          {/* <Snackbar /> */}
          {/* <StatusAlert /> */}
          {/* {displayWrongCuadreWarning < 4 ? <Routes /> : <CuadreRoute />} */}
          {forceLogout ? <CuadreRoute /> : <Routes />}
        </Paper>
      </ThemeProvider>
    </>
  );
};

// export default hot(module)(withProfiler(App));
// export default hot(module)(App);
export default App;
